<template>
  <div class="row align-items-center">
    <div
      class="col-12 my-auto mx-auto text-center justify-content-center align-items-center"
    >
      <div>
        <img
          src="https://cdn-2.powerbiz.asia/img/admin-saas/Success.png?updatedAt=1630892947577"
          width="240"
          height="240"
        />
      </div>

      <div class="col-12 d-flex flex-column">
        <div
          class="pbz-font subtitle-md-medium"
          style="color: #1a1a1a; font-size: 24px !important"
        >
          Berhasil
        </div>

        <div
          class="pbz-font body-sm-regular my-4"
          style="color: #999999 !important"
        >
          Informasi Toko Anda telah berhasil diperbarui.
        </div>

        <div class="col-12 text-center">
          <div
            class="button-selesai w-100 mx-1 pbz-font body-md-bold button-to-dashboard mb-3"
            style="color: #202759"
            @click="$emit('handleCancel')"
          >
            Selesai
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuccessEditToko',
  components: {},

  data() {
    return {}
  },
  computed: {
    id() {
      return this.$route.params.id
    },
  },

  methods: {},
}
</script>
<style scoope lang="scss">
.button-selesai {
  width: 90%;
  height: 52px;
  color: #ffffff;
  background: #202759;
  border: 1px solid #202759;
  box-sizing: border-box;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 11px;
}

.button-selesai:hover {
  background: #04449a !important;
}

.font-set-store {
  font-size: 16px;
  color: #ffffff !important;
}

.font-set-store:hover {
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: antiquewhite;
}
</style>
